import { render } from "./TheTruongMamNon_GiaoVien.vue?vue&type=template&id=319670d2"
import script from "./TheTruongMamNon_GiaoVien.vue?vue&type=script&lang=js"
export * from "./TheTruongMamNon_GiaoVien.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__